import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Authenticator } from '@aws-amplify/ui-react';

import { Layout } from './components/Layout';
import { RequireAuth, RequireRolle } from './components/Guards';
import { Landing } from './pages/Landing';
import { Impressum, Datenschutz } from './pages/Rechtstexte';
import { Uebersicht } from './pages/Uebersicht';
import { Verkostungen } from './pages/Verkostungen';
import { VerkostungDetail } from './pages/VerkostungDetail';
import { Eisdielen } from './pages/Eisdielen';
import { EisdieleDetail } from './pages/EisdieleDetail';
import { NeueVerkostung } from './pages/NeueVerkostung';
import { MeineVerkostungen } from './pages/MeineVerkostungen';
import { VerkostungBearbeiten } from './pages/VerkostungBearbeiten';
import { KarteEisdielen } from './pages/KarteEisdielen';
import { Verwaltung } from './pages/verwaltung/Verwaltung';
import { VerwaltungNutzer } from './pages/verwaltung/VerwaltungNutzer';
import { VerwaltungVerkostungen } from './pages/verwaltung/VerwaltungVerkostungen';
import { VerwaltungTestBearbeiten } from './pages/verwaltung/VerwaltungTestBearbeiten';
import { VerwaltungEisdielen } from './pages/verwaltung/VerwaltungEisdielen';
import { Bestenlisten } from './pages/Bestenlisten';

export default function App() {
  return (
    <Authenticator.Provider>
      <BrowserRouter>
        <Routes>
          {/* öffentlich */}
          <Route path="/" element={<Landing />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />

          {/* geschlossen */}
          <Route
            path="/app"
            element={
              <RequireAuth>
                <Layout />
              </RequireAuth>
            }
          >
            <Route index element={<Uebersicht />} />
            <Route path="karte" element={<KarteEisdielen />} />
            <Route path="verkostungen" element={<Verkostungen />} />
            <Route path="verkostungen/:id" element={<VerkostungDetail />} />
            <Route path="eisdielen" element={<Eisdielen />} />
            <Route path="eisdielen/:id" element={<EisdieleDetail />} />
            <Route path="bestenlisten" element={<Bestenlisten />} />

            {/* Tester + Verwalter */}
            <Route
              path="neue-verkostung"
              element={
                <RequireRolle mindestens="Tester">
                  <NeueVerkostung />
                </RequireRolle>
              }
            />
            <Route
              path="meine-verkostungen"
              element={
                <RequireRolle mindestens="Tester">
                  <MeineVerkostungen />
                </RequireRolle>
              }
            />
            <Route
              path="meine-verkostungen/:id"
              element={
                <RequireRolle mindestens="Tester">
                  <VerkostungBearbeiten />
                </RequireRolle>
              }
            />

            {/* Verwalter */}
            <Route
              path="verwaltung"
              element={
                <RequireRolle mindestens="Verwalter">
                  <Verwaltung />
                </RequireRolle>
              }
            >
              <Route index element={<VerwaltungNutzer />} />
              <Route path="nutzer" element={<VerwaltungNutzer />} />
              <Route path="verkostungen" element={<VerwaltungVerkostungen />} />
              <Route path="verkostungen/:id" element={<VerwaltungTestBearbeiten />} />
              <Route path="eisdielen" element={<VerwaltungEisdielen />} />
            </Route>
          </Route>

          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </Authenticator.Provider>
  );
}
